import { Box, styled, Typography } from '@mui/material';

export const QuestionCard = styled(Box)({
  marginBottom : '46px !important',
});

export const QuestionTitle = styled(Typography)({
  marginBottom : '14px',
  fontSize     : '16px',
  fontWeight   : '700',
  fontFamily   : 'Montserrat',
});

export const QuestionDescription = styled(Typography)(({ theme }) => ({
  marginBottom : '14px',
  marginTop    : '-7px',
  fontSize     : '16px',
  fontWeight   : '400',
  fontFamily   : 'Montserrat',
  color        : theme.palette.primary.gray6,
}));
